import { computed, ref, watch } from "vue";
import { getSlotContent } from "#ce/utils/slots";

export function useSlideshow(slidesContainer) {
  const slides = ref([]);
  const currentSlideIndex = ref(0);

  const showNavigation = computed(() => slides.value.length > 1);

  watch(slidesContainer, (container) => {
    const content = Array.from(getSlotContent(container));
    slides.value = content.filter((child) => child.tagName === "SP-HERO-ITEM");
  });

  watch(slides, initializeSlides);

  function initializeSlides() {
    goToSlide(currentSlideIndex.value);
  }

  function goToSlide(index) {
    slides.value?.forEach((slide, i) => slide.setActive?.(i === index));
  }

  return {
    slides,
    currentSlideIndex,
    showNavigation,
    initializeSlides,
    goToSlide,
  };
}
